import { Map } from 'immutable'

export const INITIAL_STATE = Map({
  jobs: [],
  progressJobs: [],
})
